<app-dialog-container
  title="{{ 'transferComponent' | translate }}"
  confirmButtonText="{{ 'transfer' | translate }}"
  [isValid]="form.valid"
  (confirmButtonHandler)="onTransfer()"
>
  <form [formGroup]="form" class="transfer-form">
    <app-ui-select
      [label]="'component' | translate"
      [placeholder]="'selectComponent' | translate"
      [options]="allComponents$ | async"
      [control]="form.componentId"
      [required]="true"
      [isMultiple]="false"
      [enableSearch]="true"
      (changeHandler)="onComponentChange($event.value)"
    ></app-ui-select>

    <app-ui-select
      [label]="'department' | translate"
      [placeholder]="'selectDepartment' | translate"
      [options]="departments$ | async"
      [control]="form.targetDepartmentId"
      [required]="true"
      [isMultiple]="false"
      (changeHandler)="onDepartmentChange($event.value)"
    ></app-ui-select>

    <app-ui-select
      [label]="'parentComponent' | translate"
      [placeholder]="'selectParentComponent' | translate"
      [options]="components$ | async"
      [control]="form.parentComponentId"
      [disabled]="!form.targetDepartmentId.value"
      [isMultiple]="false"
    ></app-ui-select>

    @if (form.targetDepartmentId.value && selectedDepartmentIds.length > 0) {
      @if (responsibleRoles$ | async; as responsibleRoles) {
        @if (responsibleRoles.length > 0) {
          <div class="role-mappings-section">
            <h3 class="role-mappings-title">{{ 'responsible' | translate }}</h3>
            <div class="role-mappings-list">
              @for (role of responsibleRoles; track role.id) {
                <div class="role-mapping-row">
                  <span class="role-name">{{ role.name }}</span>
                  <mat-icon class="role-arrow">arrow_forward</mat-icon>
                  <app-job-position-and-group-multiselect
                    [form]="getResponsibleRoleGroup(role.id)"
                    positionFieldName="position"
                    positionGroupFieldName="positionGroup"
                    [isMultiple]="false"
                    [positionsOnlyForSelectedDep]="true"
                    [selectedDepartments]="selectedDepartmentIds"
                    [skipDispatch]="true"
                    [disabled]="false"
                    [label]="'Responsible' | translate"
                    class="role-dropdown"
                  ></app-job-position-and-group-multiselect>
                </div>
              }
            </div>
          </div>
        }
      }

      @if (accessRoles$ | async; as accessRoles) {
        @if (accessRoles.length > 0) {
          <div class="role-mappings-section">
            <h3 class="role-mappings-title">{{ 'access' | translate }}</h3>
            <div class="role-mappings-list">
              @for (role of accessRoles; track role.id) {
                <div class="role-mapping-row">
                  <span class="role-name">{{ role.name }}</span>
                  <mat-icon class="role-arrow">arrow_forward</mat-icon>
                  <app-job-position-and-group-multiselect
                    [form]="getAccessRoleGroup(role.id)"
                    positionFieldName="position"
                    positionGroupFieldName="positionGroup"
                    [isMultiple]="false"
                    [positionsOnlyForSelectedDep]="true"
                    [selectedDepartments]="selectedDepartmentIds"
                    [skipDispatch]="true"
                    [disabled]="false"
                    [label]="'Access' | translate"
                    class="role-dropdown"
                  ></app-job-position-and-group-multiselect>
                </div>
              }
            </div>
          </div>
        }
      }
    }
  </form>
</app-dialog-container>
